import React, {useState, useCallback} from 'react'
import PropTypes from 'prop-types'
import {
    Drawer,
    DrawerBody,
    DrawerOverlay,
    DrawerContent,
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import QuickView from '../quick-view'

/**
 * A Drawer that renders QuickView in cart-edit mode.
 * Shows "Update" instead of "Add to Bag" and updates the existing cart item.
 * On mobile: bottom sheet (85vh). On desktop: right panel (448px).
 */
const CartEditQuickViewDrawer = ({
    isOpen,
    onClose,
    selectedItem,
    onUpdateCart
}) => {
    const initialProductId = selectedItem?.productId || selectedItem?.id
    const [productId, setProductId] = useState(initialProductId)
    const isDesktop = useBreakpointValue({base: false, lg: true}, {fallback: 'lg'})

    const placement = isDesktop ? 'right' : 'bottom'
    const drawerContentHeight = !isDesktop ? '85vh' : undefined
    const drawerContentWidth = isDesktop ? '448px' : undefined

    const handleClose = useCallback(() => {
        onClose()
    }, [onClose])

    const handleSetIsQuickViewOpen = useCallback(
        (open) => {
            if (!open) {
                onClose()
            }
        },
        [onClose]
    )

    if (!initialProductId) return null

    return (
        <Drawer
            placement={placement}
            isOpen={isOpen}
            onClose={handleClose}
            size="sm"
            scrollBehavior="inside"
            isFullHeight={isDesktop}
            returnFocusOnClose={false}
            closeOnOverlayClick={true}
        >
            <DrawerOverlay />
            <DrawerContent
                height={drawerContentHeight}
                maxHeight={drawerContentHeight}
                width={drawerContentWidth}
                maxWidth={drawerContentWidth}
                marginTop={0}
                onClick={(e) => e.stopPropagation()}
            >
                <DrawerBody padding="0">
                    <QuickView
                        productId={productId}
                        setProductId={setProductId}
                        setIsQuickViewOpen={handleSetIsQuickViewOpen}
                        showImageGallery={true}
                        themeVariant="QuickView"
                        disableFocusTrap={true}
                        forceMobileLayout={true}
                        cartEditMode={true}
                        cartEditItem={selectedItem}
                        onCartEditUpdate={onUpdateCart}
                        onQuickViewClose={handleClose}
                    />
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}

CartEditQuickViewDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedItem: PropTypes.object,
    onUpdateCart: PropTypes.func.isRequired
}

export default CartEditQuickViewDrawer
